"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFixterSegment = exports.getSegmentFromDomain = exports.getGaryDomain = exports.garyDomains = exports.getWebDomain = exports.domains = void 0;
const constants_1 = require("./constants");
exports.domains = Object.freeze({
    [constants_1.Segment.Fixter_UK]: {
        [constants_1.Stage.DEVELOPMENT]: 'fixter-dev.co.uk',
        [constants_1.Stage.STAGING]: 'fixter-staging.co.uk',
        [constants_1.Stage.PRODUCTION]: 'fixter.co.uk',
    },
    [constants_1.Segment.Fixter_FR]: {
        [constants_1.Stage.DEVELOPMENT]: 'fixter-dev.fr',
        [constants_1.Stage.STAGING]: 'fixter-staging.fr',
        [constants_1.Stage.PRODUCTION]: 'fixter.fr',
    },
    [constants_1.Segment.Motrio_FR]: {
        [constants_1.Stage.DEVELOPMENT]: 'fr.dev.fixter-nemo.com',
        [constants_1.Stage.STAGING]: 'partakus.com',
        [constants_1.Stage.PRODUCTION]: 'fr.fixter-nemo.com',
    },
});
const getWebDomain = (segment, stage) => {
    return exports.domains[segment][stage];
};
exports.getWebDomain = getWebDomain;
exports.garyDomains = Object.freeze({
    [constants_1.Segment.Fixter_UK]: {
        [constants_1.Stage.DEVELOPMENT]: 'app.garages.dev.fixter.co.uk',
        [constants_1.Stage.STAGING]: 'app.garages.staging.fixter.co.uk',
        [constants_1.Stage.PRODUCTION]: 'app.garages.fixter.co.uk',
    },
    [constants_1.Segment.Fixter_FR]: {
        [constants_1.Stage.DEVELOPMENT]: 'app.garages.dev.fixter.co.uk',
        [constants_1.Stage.STAGING]: 'app.garages.staging.fixter.co.uk',
        [constants_1.Stage.PRODUCTION]: 'app.garages.fixter.co.uk',
    },
    // @TODO - update domains
    [constants_1.Segment.Motrio_FR]: {
        [constants_1.Stage.DEVELOPMENT]: 'to.be.defined',
        [constants_1.Stage.STAGING]: 'to.be.defined',
        [constants_1.Stage.PRODUCTION]: 'to.be.defined',
    },
});
const getGaryDomain = (segment, stage) => {
    return exports.garyDomains[segment][stage];
};
exports.getGaryDomain = getGaryDomain;
const localDomains = {
    [constants_1.Segment.Fixter_UK]: 'hellofixter.co.uk',
    [constants_1.Segment.Fixter_FR]: 'hellofixter.fr',
    [constants_1.Segment.Motrio_FR]: 'fixter-nemo.local',
};
const isFixterUkDomain = (hostname) => hostname.includes(localDomains[constants_1.Segment.Fixter_UK]) ||
    hostname.includes(exports.domains[constants_1.Segment.Fixter_UK].dev) ||
    hostname.includes(exports.domains[constants_1.Segment.Fixter_UK].staging) ||
    hostname.includes(exports.domains[constants_1.Segment.Fixter_UK].production);
const isFixterFrDomain = (hostname) => hostname.includes(localDomains[constants_1.Segment.Fixter_FR]) ||
    hostname.includes(exports.domains[constants_1.Segment.Fixter_FR].dev) ||
    hostname.includes(exports.domains[constants_1.Segment.Fixter_FR].staging) ||
    hostname.includes(exports.domains[constants_1.Segment.Fixter_FR].production);
const isMotrioFrDomain = (hostname) => hostname.includes(localDomains[constants_1.Segment.Motrio_FR]) ||
    hostname.includes(exports.domains[constants_1.Segment.Motrio_FR].dev) ||
    hostname.includes(exports.domains[constants_1.Segment.Motrio_FR].staging) ||
    hostname.includes(exports.domains[constants_1.Segment.Motrio_FR].production);
const getSegmentFromDomain = (domain) => {
    if (isFixterUkDomain(domain))
        return constants_1.Segment.Fixter_UK;
    if (isFixterFrDomain(domain))
        return constants_1.Segment.Fixter_FR;
    if (isMotrioFrDomain(domain))
        return constants_1.Segment.Motrio_FR;
    return constants_1.Segment.Fixter_UK;
};
exports.getSegmentFromDomain = getSegmentFromDomain;
const isFixterSegment = (segment) => {
    if (segment.includes('FIXTER'))
        return true;
    return false;
};
exports.isFixterSegment = isFixterSegment;
//# sourceMappingURL=domain.js.map